export const sumOfRecoveryBill = (calculatorUtilities) => {
  let newTotalBill = 0;
  for (let val in calculatorUtilities) {
    newTotalBill += calculatorUtilities[val].ATP;
  }

  return newTotalBill;
};
